import { CanvasRect } from 'components/ps-chart/models/helper-types'

export enum BorderType {
  PRIMARY = 'primary',
  UNFOCUSED = 'native',
  SECONDARY = 'secondary',
  ACTIVE = 'active',
}

export const AllBorderTypes = [
  BorderType.PRIMARY,
  BorderType.UNFOCUSED,
  BorderType.SECONDARY,
  BorderType.ACTIVE,
]

export enum LineType {
  PRIMARY = 'primary',
  UNFOCUSED = 'native',
  SECONDARY = 'secondary',
  ACTIVE = 'active',
  DISABLED = 'disabled',
}

export const AllLineTypes = [
  LineType.PRIMARY,
  LineType.UNFOCUSED,
  LineType.SECONDARY,
  LineType.ACTIVE,
  LineType.DISABLED,
]

export interface NodeRenderData {
  rect: CanvasRect
  isFav: boolean
  borderType: BorderType
}
